<template>
  <div :class="classes" v-bind="$attrs" v-on="$listeners"></div>
</template>

<script>
export default {
  props: {
    /**
     * Two-letters country code in ISO 3166-1 alpha-2, officially assigned: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
     */
    country: {
      type: String,
      default: ""
    }
  },
  computed: {
    classes() {
      return ["am-flag", `${this.country}`.toLowerCase()];
    }
  }
};
</script>
